import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { CibPlaceVoteComponent } from '../../../cib-place-vote/cib-place-vote.component';
import { DateFormatPipe } from '../../../../../controls/pipes/date-format.pipe';
import { IBallotCommitteeMemberDto } from '../../../../shared/models/ballot-base/ballot-committee-member-dto';


@Component({
    selector: 'app-cib-history-column',
    templateUrl: './cib-history-column.component.html',
    styleUrl: './cib-history-column.component.scss',
    standalone: false
})
export class CibHistoryColumnComponent {
  @Input() vote: IBallotCommitteeMemberDto | null = null;
  @Input() isProxyVoteEnable: boolean = false;
  @Input() afterSaveSubject: Subject<string> = new Subject<string>();

  isEligible: boolean = false;
  lastUpdated: string = '';

    constructor(
      private _modalService: NgbModal,
      private dateFormatPipe: DateFormatPipe
    ) {}

  ngOnInit(): void {
    if (this.vote && this.vote.lastUpdated) {
      this.isEligible = this.vote.isEligible;
      this.lastUpdated = this.dateFormatPipe.transform(this.vote.lastUpdated);
    }
  }


  openProxyVoteModal() {
    const modalRef = this._modalService.open(CibPlaceVoteComponent, { windowClass: 'place-vote-custom-modal', centered: true});
    modalRef.componentInstance.votes = [this.vote];
    modalRef.componentInstance.isProxyVote = true;
    modalRef.result.then(
    (result) => {
      console.log('Modal closed with:', result);
    },
    vote => {
      if (vote) {
        this.afterSaveSubject.next(this.vote?.ballotId??"");
      }
    })
  }
}
